import CONSTANT from "../../../../constants/Constant";
import GLOBAL from "../../../../global";
import { getTenantFeatures } from "../../../../features/tenantFeatures/useTenantFeature";

const { REACT_APP_CHAT_API_URL } = process.env;
const BOT_URL = REACT_APP_CHAT_API_URL + `/api/${CONSTANT.BOT_API_VERSION}/chat`;

export const createBotOptionFactory = (options, additionalOptions = {}) => {
    const botInfo = { ...options.botInfo };

    if(options.name === CONSTANT.CHAT_BOTS.MSK_BOT) {
        const { isExamineticsEnabled } = getTenantFeatures();
        if (isExamineticsEnabled) {
            botInfo.subName = CONSTANT.MSK_BOT_INFO.subNames.examinetics;
        } else if (GLOBAL.USER_INFO?.Permissions?.IsSpinealignEnabled === true) {
            botInfo.subName = CONSTANT.MSK_BOT_INFO.subNames.pbn;
        } else if (GLOBAL.USER_INFO?.Permissions?.IsAthleteEnabled === true) {
            botInfo.subName = CONSTANT.MSK_BOT_INFO.subNames.athlete;
        } else {
            botInfo.subName = CONSTANT.MSK_BOT_INFO.subNames.default;
        }
    }

    return {
        botInfo: botInfo,
        options: {
            name: options.name,
            apiUrl: options.apiUrl,
            ...additionalOptions
        }
    };
};

export const createBotOption = (options, additionalOptions = {}) => {
    return createBotOptionFactory(options, additionalOptions);
};

export const mskOptions = {
    botInfo: CONSTANT.MSK_BOT_INFO,
    name: CONSTANT.CHAT_BOTS.MSK_BOT,
    apiUrl: BOT_URL,
};

export const postureOptions = {
    botInfo: CONSTANT.POSTURE_BOT_INFO,
    name: CONSTANT.CHAT_BOTS.POSTURE_BOT,
    apiUrl: BOT_URL,
};

export const intakeOptions = {
    botInfo: CONSTANT.INTAKE_BOT_INFO,
    name: CONSTANT.CHAT_BOTS.INTAKE_BOT,
    apiUrl: BOT_URL,
};
